var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import axios from "axios";
import JSZip from "jszip";
import { EDITOR_NAME, EDITOR_VERSION } from "../constants";
var baseURL = "https://tmc.mooc.fi/api/v8";
var getHeaders = function getHeaders(token, additional) {
  return __assign(__assign({}, additional), {
    Authorization: "Bearer " + token,
    client: EDITOR_NAME,
    client_version: EDITOR_VERSION
  });
};
var getZipFromUrl = function getZipFromUrl(url, configuration) {
  return __awaiter(void 0, void 0, void 0, function () {
    var t, token, zip, response, error_1;
    var _a;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          t = configuration.t, token = configuration.token;
          _b.label = 1;
        case 1:
          _b.trys.push([1, 4,, 5]);
          zip = new JSZip();
          return [4, axios.get(url, {
            headers: getHeaders(token),
            responseType: "arraybuffer"
          })];
        case 2:
          response = _b.sent();
          return [4, zip.loadAsync(response.data)];
        case 3:
          return [2, _b.sent()];
        case 4:
          error_1 = _b.sent();
          throw ((_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _a === void 0 ? void 0 : _a.status) ? new Error(error_1.response.status + ": " + t("failedToDownloadExercise")) : new Error("418: " + t("failedToEstablishConnectionToServer"));
        case 5:
          return [2];
      }
    });
  });
};
var getExerciseDetails = function getExerciseDetails(organization, course, exercise, configuration) {
  return __awaiter(void 0, void 0, void 0, function () {
    var t, token, url, headers, data, error_2;
    var _a, _b, _c;
    return __generator(this, function (_d) {
      switch (_d.label) {
        case 0:
          t = configuration.t, token = configuration.token;
          url = baseURL + "/org/" + organization + "/courses/" + course + "/exercises/" + exercise;
          headers = getHeaders(token);
          _d.label = 1;
        case 1:
          _d.trys.push([1, 3,, 4]);
          return [4, axios.get(url, {
            headers: headers,
            responseType: "json"
          })];
        case 2:
          data = _d.sent().data;
          return [2, {
            id: data.id,
            availablePoints: (_a = data.available_points) === null || _a === void 0 ? void 0 : _a.length,
            awardedPoints: (_b = data.awarded_points) === null || _b === void 0 ? void 0 : _b.length,
            completed: data.completed,
            deadline: data.deadline,
            downloadable: data.downloadable,
            expired: data.expired,
            softDeadline: data.soft_deadline,
            unlocked: data.unlocked
          }];
        case 3:
          error_2 = _d.sent();
          throw ((_c = error_2 === null || error_2 === void 0 ? void 0 : error_2.response) === null || _c === void 0 ? void 0 : _c.status) ? new Error(error_2.response.status + ": " + t("couldNotFindExerciseDetails")) : new Error("418: " + t("failedToEstablishConnectionToServer"));
        case 4:
          return [2];
      }
    });
  });
};
var getExerciseZip = function getExerciseZip(organization, course, exercise, configuration) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2, getZipFromUrl(baseURL + "/org/" + organization + "/courses/" + course + "/exercises/" + exercise + "/download", configuration)];
    });
  });
};
export var getOldSubmissions = function getOldSubmissions(exerciseId, configuration) {
  return __awaiter(void 0, void 0, void 0, function () {
    var t, token, url, headers, submissions, response, error_3;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          t = configuration.t, token = configuration.token;
          url = baseURL + "/exercises/" + exerciseId + "/users/current/submissions";
          headers = getHeaders(token);
          _a.label = 1;
        case 1:
          _a.trys.push([1, 3,, 4]);
          return [4, axios.get(url, {
            headers: headers,
            responseType: "json"
          })];
        case 2:
          response = _a.sent();
          submissions = response.data;
          return [3, 4];
        case 3:
          error_3 = _a.sent();
          throw new Error(error_3.response.status + ": " + t("failedToDownloadExercise"));
        case 4:
          return [2, submissions.map(function (submission) {
            return {
              id: submission.id,
              createdAtMillis: Date.parse(submission.created_at)
            };
          })];
      }
    });
  });
};
export var getSubmissionZip = function getSubmissionZip(submissionId, configuration) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2, getZipFromUrl(baseURL + "/core/submissions/" + submissionId + "/download", configuration)];
    });
  });
};
var getModelSolutionZip = function getModelSolutionZip(exerciseId, configuration) {
  return getZipFromUrl(baseURL + "/core/exercises/" + exerciseId + "/solution/download", configuration);
};
var getSubmissionResults = function getSubmissionResults(submissionResponse, configuration) {
  return __awaiter(void 0, void 0, void 0, function () {
    var t, token, headers, times, _loop_1, _i, times_1, time, state_1;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          t = configuration.t, token = configuration.token;
          headers = getHeaders(token);
          times = [2000, 2000, 1000, 1000, 1000, 2000, 2000, 4000, 8000, 16000];
          _loop_1 = function _loop_1(time) {
            var submissionStatus, error_4, tests, testCases, points;
            return __generator(this, function (_b) {
              switch (_b.label) {
                case 0:
                  return [4, new Promise(function (resolve) {
                    return setTimeout(resolve, time);
                  })];
                case 1:
                  _b.sent();
                  submissionStatus = void 0;
                  _b.label = 2;
                case 2:
                  _b.trys.push([2, 4,, 5]);
                  return [4, axios.get(submissionResponse.submissionUrl, {
                    headers: headers,
                    responseType: "json"
                  })];
                case 3:
                  submissionStatus = _b.sent().data;
                  return [3, 5];
                case 4:
                  error_4 = _b.sent();
                  console.error(error_4.response);
                  submissionStatus = {
                    status: "error",
                    statusCode: error_4.response.status
                  };
                  return [3, 5];
                case 5:
                  if (submissionStatus.status === "error") {
                    throw new Error(submissionStatus.statusCode + ": " + t("submissionProcessFailed"));
                  } else if (submissionStatus.status !== "processing") {
                    tests = submissionStatus.test_cases;
                    testCases = tests.map(function (test, index) {
                      return {
                        id: index.toString(),
                        testName: test.name,
                        passed: test.successful,
                        feedback: test.message
                      };
                    });
                    points = submissionStatus.points;
                    return [2, {
                      value: {
                        allTestsPassed: submissionStatus.all_tests_passed,
                        points: points,
                        testCases: testCases,
                        feedbackQuestions: submissionStatus.feedback_questions,
                        feedbackAnswerUrl: submissionStatus.feedback_answer_url,
                        solutionUrl: submissionStatus.solution_url
                      }
                    }];
                  }
                  return [2];
              }
            });
          };
          _i = 0, times_1 = times;
          _a.label = 1;
        case 1:
          if (!(_i < times_1.length)) return [3, 4];
          time = times_1[_i];
          return [5, _loop_1(time)];
        case 2:
          state_1 = _a.sent();
          if (typeof state_1 === "object") return [2, state_1.value];
          _a.label = 3;
        case 3:
          _i++;
          return [3, 1];
        case 4:
          throw new Error("418: " + t("submissionTookTooLong"));
      }
    });
  });
};
var postExerciseSubmission = function postExerciseSubmission(exerciseId, files, configuration, submissionOptions) {
  return __awaiter(void 0, void 0, void 0, function () {
    var t, token, headers, paste, zip, form, _a, _b, _c, response, error_5, status_1, message;
    return __generator(this, function (_d) {
      switch (_d.label) {
        case 0:
          t = configuration.t, token = configuration.token;
          headers = getHeaders(token, {
            "Content-Type": "multipart/form-data"
          });
          paste = (submissionOptions === null || submissionOptions === void 0 ? void 0 : submissionOptions.paste) || false;
          zip = new JSZip();
          files.forEach(function (file) {
            zip.file(file.fullName, file.content);
          });
          form = new FormData();
          paste && form.append("paste", "1");
          _b = (_a = form).append;
          _c = ["submission[file]"];
          return [4, zip.generateAsync({
            type: "blob"
          })];
        case 1:
          _b.apply(_a, _c.concat([_d.sent()]));
          _d.label = 2;
        case 2:
          _d.trys.push([2, 4,, 5]);
          return [4, axios.post(baseURL + "/core/exercises/" + exerciseId + "/submissions", form, {
            headers: headers
          })];
        case 3:
          response = _d.sent();
          return [2, {
            pasteUrl: paste ? response.data.paste_url : undefined,
            showSubmissionUrl: response.data.show_submission_url,
            submissionUrl: response.data.submission_url
          }];
        case 4:
          error_5 = _d.sent();
          status_1 = error_5.response.status;
          message = status_1 === 403 ? t("authenticationRequired") : t("submissionProcessFailed");
          console.error(error_5.response);
          throw new Error(status_1 + ": " + message);
        case 5:
          return [2];
      }
    });
  });
};
var postExerciseFeedback = function postExerciseFeedback(testResults, feedback, configuration) {
  return __awaiter(void 0, void 0, void 0, function () {
    var token, headers, form, error_6;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          token = configuration.token;
          headers = getHeaders(token, {
            "Content-Type": "multipart/form-data"
          });
          if (!testResults.feedbackAnswerUrl || testResults.feedbackAnswerUrl === "") {
            return [2];
          }
          form = new FormData();
          feedback.forEach(function (answer, index) {
            form.append("answers[" + index + "][question_id]", answer.questionId.toString());
            form.append("answers[" + index + "][answer]", answer.answer.toString());
          });
          _a.label = 1;
        case 1:
          _a.trys.push([1, 3,, 4]);
          return [4, axios.post(testResults.feedbackAnswerUrl, form, {
            headers: headers
          })];
        case 2:
          _a.sent();
          return [2];
        case 3:
          error_6 = _a.sent();
          throw new Error(error_6.response.status + ": " + JSON.parse(error_6.response));
        case 4:
          return [2];
      }
    });
  });
};
export { getExerciseDetails, getExerciseZip, getModelSolutionZip, getSubmissionResults, postExerciseFeedback, postExerciseSubmission };